'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const VERSION = "bb29b690";
const ZINNIA_BETA_STYLESHEET_URL = `https://design-system-css.zapier.com/design-system-beta/${VERSION}.css`;
const ZinniaBetaStylesheet = (props) => {
  return React__default.default.createElement("link", Object.assign({ href: ZINNIA_BETA_STYLESHEET_URL, rel: "stylesheet" }, props));
};

exports.ZINNIA_BETA_STYLESHEET_URL = ZINNIA_BETA_STYLESHEET_URL;
exports.ZinniaBetaStylesheet = ZinniaBetaStylesheet;
//# sourceMappingURL=ZinniaBetaStylesheet.cjs.js.map
